<!--模板管理-->
<template>
  <a-card>
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="模板名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.name"
                   placeholder="请输入模板名称" />
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px;">
          <a-button @click="getPageList(1)" type="primary" html-type="button">
            查询
          </a-button>
          <a-button @click="searchReset" style="margin-left: 10px;">
            重置
          </a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`templateManage.Add`">
          <a-button @click="addEditTemplate()" icon="plus" type="primary">添加模板</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-table style="min-width: 800px;"
             :columns="columns"
             :rowKey="(text, index) => text.id+ '_' + index"
             :pagination="false"
             :loading="table.tableLoading"
             :dataSource="table.tableDataSource">
      <a-switch v-if="text.id" slot="enabled" slot-scope="text,record"
                @change="tableStatusChange(text)" v-model="text.enabled"
                checked-children="启用"
                un-checked-children="禁用" />
      <div v-if="text.id" slot="operate" class="operate" slot-scope="text,record">
        <a-button @click="editVersion(text)" icon="edit" type="link">编辑</a-button>
        <a-dropdown>
          <a-button icon="down" type="link">预览</a-button>
          <a-menu slot="overlay">
            <a-menu-item @click="view(text)">
              网页模板
            </a-menu-item>
            <a-menu-item @click="view(text, 'h5')">
              h5模板
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-popconfirm title="确认删除此模板？" @confirm="deleteTemplate(text)">
          <a-button danger icon="delete" type="link">删除</a-button>
        </a-popconfirm>
      </div>
    </a-table>

    <!--添加/编辑版本-->
    <a-modal v-model="modelForm.visible"
             :centered="true"
             :destroyOnClose="true"
             :title="modelForm.title"
             :confirm-loading="modelForm.confirmLoading"
             @cancel="modelFormCancel"
             @ok="modelFormOk" width="800px">
      <a-form-model ref="myModelForm"
                    style="max-height: 550px;overflow-y: auto;"
                    :labelCol="{ span: 6 }"
                    :wrapperCol="{ span: 16 }"
                    :model="modelForm.data"
                    :rules="modelForm.rules">
        <a-form-model-item label="分组名称" prop="templateGroup">
          <!--<a-input v-model.trim="modelForm.data.templateGroup" :maxLength="50" placeholder="请输入">
            <span class="input-number" slot="suffix">{{ modelForm.data.templateGroup.length || 0 }} / 50</span>
          </a-input>-->
          <a-select v-model="modelForm.data.templateGroup" @search="templateGroupSearch" show-search placeholder="请输入" allowClear>
            <a-select-option v-for="item in table.tableDataSource" :value="item.templateGroup">
              {{ item.templateGroup }}
            </a-select-option>
            <a-select-option v-if="modelForm.templateGroupInput && !table.tableDataSource.some(s => item.templateGroup === modelForm.templateGroupInput)"
                             :value="modelForm.templateGroupInput">
              {{ modelForm.templateGroupInput }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="模板名称" prop="name">
          <a-input v-model.trim="modelForm.data.name" :maxLength="50" placeholder="请输入">
            <span class="input-number" slot="suffix">{{ modelForm.data.name.length || 0 }} / 50</span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="模板类型" prop="templateType">
          <a-radio-group v-model="modelForm.data.templateType">
            <a-radio :value="1">测评模板</a-radio>
            <a-radio :value="2">训练模板</a-radio>
            <a-radio :value="3">活动模板</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <div style="position: relative;">
            <a-input v-model="modelForm.data.remark"
                     type="textarea"
                     class="input-textarea"
                     placeholder="请输入"
                     :maxLength="100"
                     :auto-size="{ minRows: 3}" />
            <span class="input-textarea-number">{{ modelForm.data.remark.length || 0 }} / 100</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="enabled">
          <a-radio-group v-model="modelForm.data.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="modelForm.data.templateType !== 2" label="能力类型" prop="abilityIds">
          <a-tree-select :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                         placeholder="请选择"
                         treeNodeFilterProp="title"
                         :tree-data="modelForm.abilityList"
                         :replaceFields="{ children:'children', title:'name', key:'id', value: 'id' }"
                         allow-clear
                         multiple
                         v-model="modelForm.data.abilityIds" />
        </a-form-model-item>
        <a-form-model-item v-if="modelForm.data.templateType !== 2" label="能力体系" prop="abilityEvaluationSysId">
          <a-select v-model="modelForm.data.abilityEvaluationSysId" placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in modelForm.abilityEvaluation">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-collapse :activeKey="['1', '2']">
          <a-collapse-panel key="1" header="网页模板">
            <a-form-model-item label="预览链接" prop="previewUrl">
              <a-input v-model.trim="modelForm.data.previewUrl" :maxLength="3000" placeholder="请输入">
                <span class="input-number" slot="suffix">{{ modelForm.data.previewUrl.length || 0 }} / 3000</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="内容" prop="context">
              <a-textarea v-model="modelForm.data.context"
                          placeholder="请输入内容"
                          :auto-size="{ minRows: 3, maxRows: 8 }" />
            </a-form-model-item>
          </a-collapse-panel>
          <a-collapse-panel key="2" header="h5模板">
            <a-form-model-item label="预览链接" prop="h5PreviewUrl">
              <a-input v-model.trim="modelForm.data.h5PreviewUrl" :maxLength="3000" placeholder="请输入">
                <span class="input-number" slot="suffix">{{ modelForm.data.h5PreviewUrl.length || 0 }} / 3000</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="内容" prop="h5Context">
              <a-textarea v-model="modelForm.data.h5Context"
                          placeholder="请输入内容"
                          :auto-size="{ minRows: 3, maxRows: 8 }" />
            </a-form-model-item>
          </a-collapse-panel>
        </a-collapse>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";

const columns = [
  { title: "模板名称", dataIndex: "name", align: "left" },
  { title: "备注", dataIndex: "remark", align: "left" },
  { title: "状态", scopedSlots: { customRender: "enabled" }, align: "left" },
  { title: "更新时间", dataIndex: "updateTime", align: "left" },
  { title: "操作", scopedSlots: { customRender: "operate" }, align: "left" },
];
export default {
  name: "TemplateManage",
  data() {
    return {
      columns,
      searchForm: {
        name: undefined,
      },
      //表格相关
      table: tableRelevant.call(this),
      modelForm: {
        visible: false,
        confirmLoading: false,
        abilityList: [],
        //评价体系下拉列表
        abilityEvaluation: [],
        title: "添加模板",
        templateGroupInput: "",
        data: {
          id: undefined,
          templateType: undefined,
          name: "",
          templateGroup: "",
          context: "",
          abilityIds: [],
          abilityEvaluationSysId: undefined,
          enabled: true,
          remark: "",
          previewUrl: "",
          h5PreviewUrl: "",
          h5Context: "",
        },
        rules: {
          templateGroup: [
            { required: true, message: "请输入分组名称", trigger: "blur" },
            { min: 1, max: 50, message: "分组名称长度为 1 到 50个字", trigger: "change" },
          ],
          name: [
            { required: true, message: "请输入模板名称", trigger: "blur" },
            { min: 1, max: 50, message: "模板名称长度为 1 到 50个字", trigger: "change" },
          ],
          templateType: [{ required: true, message: "请选择模板类型", trigger: "change" }],
          abilityEvaluationSysId: [{ required: true, message: "请选择能力体系", trigger: "change" }],
          enabled: [{ required: true, message: "请选择状态", trigger: "change" }],
          abilityIds: [{ type: "array", required: true, message: "请选择能力", trigger: "change" }],
          previewUrl: [{ required: true, message: "请输入报告链接", trigger: "change" }],
          remark: [{ required: true, message: "请输入区别于其他版本的信息", trigger: "change" }],
          context: [{ required: true, message: "请输入模板内容", trigger: "change" }],
        },
      },
    };
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    getAbility() {
      if (this.modelForm.abilityList.length) {
        return;
      }
      this.$http.courseAbilitySelect({ abilityType: 0 }).then(res => {
        const { data } = res.data;
        function tree(arr) {
          return arr.map(m => {
            m.selectable = m.levelNumber === 1;
            if (m.selectable) {
              m.isLeaf = true;
              m.children = [];
            }
            if (m.children && m.children.length) {
              m.children = tree(m.children);
            }
            return m;
          });
        }

        this.modelForm.abilityList = tree(data);
      });
    },
    //获取评价体系列表
    getAbilityEvaluation() {
      if (!this.modelForm.abilityEvaluation.length) {
        this.$http.ReportService.getAbilityEvaluationSys().then(res => {
          this.modelForm.abilityEvaluation = res.data.filter(f => f.enabled);
        })
      }
    },
    addEditTemplate() {
      this.modelForm.visible = true;
      this.modelForm.data.templateGroup = undefined;
      this.getAbility();
      this.getAbilityEvaluation();
    },
    editVersion(record) {
      this.modelForm.title = "编辑模板";
      this.modelForm.data.id = record.id;
      this.modelForm.visible = true;
      this.getAbility();
      this.getAbilityEvaluation();
      this.$http.ReportService.ReportTemplatesDetails(record.id).then(res => {
        for (let key in this.modelForm.data) {
          if (typeof res.data[key] !== "undefined") {
            this.modelForm.data[key] = res.data[key];
          }
        }
        this.modelForm.data.abilityEvaluationSysId = res.data.abilityEvaluationSysId || undefined;
      });
    },
    //弹出框确认
    modelFormOk() {
      this.$refs.myModelForm.validate(valid => {
        if (valid) {
          if (this.modelForm.data.templateType === 2) {
            this.modelForm.data.abilityIds = [];
            this.modelForm.data.abilityEvaluationSysId = undefined;
          }
          this.modelForm.confirmLoading = true;
          let Ajax = this.$http.ReportService.ReportTemplatesAdd;
          if (this.modelForm.title === "编辑模板") {
            Ajax = this.$http.ReportService.ReportTemplatesUpdate;
          }
          Ajax(this.modelForm.data).then(res => {
            this.$message.success(res.message);
            this.modelFormCancel();
            this.getPageList();
          }).finally(() => {
            this.modelForm.confirmLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //弹出框取消
    modelFormCancel() {
      this.modelForm.visible = false;
      this.modelForm.title = "添加模板";
      this.modelForm.data = {
        id: undefined,
        templateType: undefined,
        name: "",
        templateGroup: "",
        context: "",
        abilityIds: [],
        abilityEvaluationSysId: undefined,
        enabled: true,
        remark: "",
        previewUrl: "",
        h5PreviewUrl: "",
        h5Context: "",
      };
    },
    //模板状态切换
    tableStatusChange(text) {
      const Params = {
        "id": text.id,
        "enabled": text.enabled,
      };
      this.$http.ReportService.ReportTemplatesUpdateEnabled(Params).then(res => {
        this.$message.success(res.message);
      }).catch(() => {
        text.enabled = !text.enabled;
      })
    },

    deleteTemplate(record) {
      this.$http.ReportService.ReportTemplatesDelete(record.id).then(res => {
        this.$message.success(res.message);
        this.getPageList();
      });
    },
    // 预览
    view(record, type) {
      if (type === "h5") {
        window.open(record.h5PreviewUrl);
        return;
      }
      window.open(record.previewUrl);
    },


    //获取模板列表
    getPageList() {
      this.table.tableLoading = true;
      this.$http.ReportService.ReportTemplates(this.searchForm).then(res => {
        this.table.tableDataSource = res.data.map(m => {
          m.name = m.templateGroup;
          m.children = m.reportTemplates
          return m;
        });
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },

    //重置
    searchReset() {
      this.searchForm.name = undefined;
      this.getPageList();
    },

    templateGroupSearch(value){
      this.modelForm.templateGroupInput = typeof value === "string" ? value.trim() : "";
      this.modelForm.data.templateGroup = this.modelForm.templateGroupInput.length ? this.modelForm.templateGroupInput : this.modelForm.data.templateGroup;
    }
  },
};
</script>

<style scoped lang="less">
.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.input-textarea {
  resize: none;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.input-textarea-number {
  position: absolute;
  bottom: 0;
  right: 11px;
  font-size: 13px;
  color: #bbb;
}

.input-number {
  font-size: 13px;
  color: #bbb;
}

/deep/ .ant-input {
  padding-right: 77px !important;
}
</style>
